<template>
  <hm-content title="">
    <div class="mb10 flex flex-between">
      <el-button type="primary" size="small" @click="add"
        >新增获取规则</el-button
      >
      <div>
        <el-select
          size="small"
          clearable
          placeholder="请选择时间状态"
          v-model="ruleForm.timeStatus"
          class="mr10"
          filterable
        >
          <el-option label="未开始" value="notStart"></el-option>
          <el-option label="进行中" value="going"></el-option>
          <el-option label="已结束" value="end"></el-option>
        </el-select>
        <el-select
          size="small"
          clearable
          placeholder="请选择金豆状态"
          v-model="ruleForm.useStatus"
          class="mr10"
          filterable
        >
          <el-option label="开启" value="yes"></el-option>
          <el-option label="关闭" value="no"></el-option>
        </el-select>
        <el-input
          style="width:280px"
          clearable
          v-model.trim="searchCondition.name"
          placeholder="请输入金豆别称"
          size="small"
          class="ipt mr10"
        >
        </el-input>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
    </div>
    <div class="table">
      <el-table
        :data="list"
        style="width: 100%"
        stripe
        size="small"
        border
        ref="table"
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="获取金豆名称"
          prop="name"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="关联金豆"
          prop="ruleName"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createTime"
          label="创建时间"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="金豆获取时间"
          width="290"
        >
          <template slot-scope="scope">
            <div class="flex item-center">
              {{ scope.row.startTime }} - {{ scope.row.endTime }}
              <i
                v-if="
                  scope.row.useStatus === 'yes' &&
                    scope.row.timeStatus !== 'notStart'
                "
                @click="editEndTime(scope.row)"
                class="el-icon-edit-outline blue ml10 pointer"
                style="font-size:20px"
              ></i>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="timeStatus"
          label="时间状态"
        >
          <template slot-scope="scope">
            <div class="blue" v-if="scope.row.timeStatus === 'notStart'">
              未开始
            </div>
            <div class="success" v-else-if="scope.row.timeStatus === 'going'">
              进行中
            </div>
            <div class="gray" v-else-if="scope.row.timeStatus === 'end'">
              已过期
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="useStatus"
          label="活动状态"
        >
          <template slot-scope="scope">
            <div :class="scope.row.useStatus === 'yes' ? 'success' : 'danger'">
              {{ scope.row.useStatus === "yes" ? "开启" : "作废" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="sendWayType"
          label="获取方式"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.sendWayType === 'online'">线上交易</div>
            <div v-if="scope.row.sendWayType === 'offline'">线下交易</div>
            <div v-if="scope.row.sendWayType === 'syncIntegral' || scope.row.sendWayType === 'integral'">同步积分</div>
          </template>
        </el-table-column>

        <el-table-column
          label="操作"
          header-align="center"
          align="center"
          width="200"
        >
          <template slot-scope="scope">
            <div class="flex flex-center item-center">
              <el-button
                type="text"
                size="small"
                @click="remove(scope.row)"
                :disabled="scope.row.useStatus === 'no'"
              >
                作废
              </el-button>
              <el-divider direction="vertical"></el-divider>
              <el-button
                type="text"
                size="small"
                :class="scope.row.useStatus === 'no' ? 'gray' : 'blue'"
                @click="detail(scope.row, 'edit')"
                :disabled="scope.row.useStatus === 'no'"
              >
                编辑
              </el-button>
              <el-divider direction="vertical"></el-divider>
              <el-button
                type="text"
                size="small"
                class="blue"
                @click="detail(scope.row, 'detail')"
              >
                查看
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible.sync="dialogVisible"
    >
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-width="150px"
      >
        <el-form-item label="金豆别称" prop="categoryName">
          <el-input
            v-model.trim="ruleForm.categoryName"
            size="small"
            clearable
            style="width:350px"
            placeholder="请输入金豆名，不超过5个字（手机端金豆名称显示）"
          ></el-input>
        </el-form-item>
        <el-form-item label="金豆使用订单门槛" prop="categoryPrice">
          <el-input
            v-model.trim="ruleForm.categoryPrice"
            maxlength="20"
            size="small"
            clearable
            placeholder="请输入金额"
            @input="filterGt0OrFixed2('categoryPrice')"
          ></el-input>
          <div class="form-item-tip">
            订单金额达到多少才允许使用金豆支付
          </div>
        </el-form-item>
        <el-form-item label="金豆使用比例" prop="categoryRadio">
          使用
          <el-input
            v-model.trim="ruleForm.categoryRadio"
            maxlength="20"
            clearable
            size="small"
            placeholder="请输入金豆数量"
            @input="filterGt0OrFixed0('categoryRadio')"
          ></el-input
          >金豆=1元
        </el-form-item>
        <el-form-item label="金豆使用满足倍数" prop="categoryMultiple">
          使用
          <el-input
            v-model.trim="ruleForm.categoryMultiple"
            maxlength="20"
            clearable
            size="small"
            placeholder="请输入整数"
            @input="filterGt0OrFixed0('categoryMultiple')"
          ></el-input
          >倍
          <div class="form-item-tip">
            金豆达到指定倍数才能使用，例如10倍，则金豆数只能10倍抵扣，例如10金豆、20金豆.以此类推
          </div>
        </el-form-item>
        <el-form-item label="使用金豆时间" prop="applyDate">
          <el-date-picker
            v-model="ruleForm.applyDate"
            type="datetimerange"
            align="right"
            ref="applyDatePicker"
            :default-time="['00:00:00', '23:59:59']"
            start-placeholder="报名开始时间"
            end-placeholder="报名结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            size="small"
            class="mr10"
          ></el-date-picker>
        </el-form-item>
      </el-form>

      <div class="btn-wrapper flex flex-center" slot="footer">
        <el-button size="small" type="primary" @click="save">确 定</el-button>
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="dialogVisibleDate"
      width="40%"
      title="修改金豆获取结束时间"
    >
      <div class="flex mb20">
        <div class="mr20">获取金豆名称:{{ row.name }}</div>
        <div>关联金豆:{{ row.ruleName }}</div>
      </div>
      <div class="mb20">
        开始时间：
        <el-date-picker
          disabled
          v-model="startTime"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          placeholder="开始时间"
          size="small"
          class="mr10"
        >
        </el-date-picker>
      </div>

      <div>
        结束时间：
        <el-date-picker
          size="small"
          :editable="false"
          v-model="endTime"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="结束时间"
          :default-time="'23:59:59'"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
      </div>
      <div class="btn-wrapper flex flex-center" slot="footer">
        <el-button size="small" type="primary" @click="edit">确 定</el-button>
        <el-button size="small" @click="dialogVisibleDate = false"
          >取 消</el-button
        >
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
export default {
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      startTime: "",
      endTime: "",
      title: "",
      dialogVisibleDate: false,
      dialogVisible: false,
      ruleForm: {
        categoryName: "",
        categoryPrice: "",
        categoryRadio: "",
        categoryMultiple: "",
        applyDate: ""
      },
      rules: {
        categoryName: [
          {
            required: true,
            trrger: "change",
            message: "请输入金豆别称"
          },
          { max: 5, message: "长度在5个字符内", trigger: "change" }
        ],
        categoryPrice: {
          required: true,
          trrger: "change",
          message: "请输入金额"
        },
        categoryRadio: {
          required: true,
          trrger: "change",
          message: "请输入金豆数量"
        },
        categoryMultiple: {
          required: true,
          trrger: "change",
          message: "请输入整数"
        },
        applyDate: {
          required: true,
          trrger: "change",
          message: "请输入时间段"
        }
      },
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchCondition: {},
      type: "",
      row: {}
    };
  },
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    editEndTime(row) {
      this.row = row;
      this.dialogVisibleDate = true;
      this.startTime = row.startTime;
      this.endTime = row.endTime;
    },
    async edit() {
      if (this.endTime) {
        await this.$store.dispatch("editStoreGoldBeanSend", {
          sendId: this.row.sendId,
          endTime: this.endTime
        });
        this.$message({
          type: "success",
          message: "操作成功！"
        });
        this.dialogVisibleDate = false;
        this.row = {};
        this.startTime = "";
        this.endTime = "";
        this.queryList();
      } else {
        this.$message({
          message: "请选择结束日期！",
          type: "warning"
        });
      }
    },
    filterGt0OrFixed2(prop) {
      this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (this.ruleForm[prop].indexOf(".") < 0 && this.ruleForm[prop] != "") {
        //首位是0的话去掉
        this.ruleForm[prop] = parseFloat(this.ruleForm[prop]);
      }
    },
    filterGt0OrFixed0(prop) {
      this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\d]/g, "");
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "")
        .replace("-", "")
        .replace(",", "");

      this.ruleForm[prop] = new Number(this.ruleForm[prop]);
    },
    add() {
      this.$router.push({
        name: "SettingFortunellaVenosaRule",
        query: {
          type: "add"
        }
      });
    },
    async save() {
      const { valid } = await this.$refs.ruleForm.validate();
      console.log("valid: ", valid);
      if (valid) {
      } else {
        return;
      }
    },
    async remove(row) {
      const result = await this.$confirm(" 删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).catch(() => {});
      if (result === "confirm") {
        this.$store.dispatch("editStoreGoldBeanSendInvalid", {
          sendId: row.sendId
        });
        this.$message({
          message: " 操作成功",
          type: "success"
        });
        this.queryList();
        console.log("result: ", result);
      }
    },
    detail(row, type) {
      this.row = row;
      this.type = type;
      this.$router.push({
        name: "SettingFortunellaVenosaRule",
        query: {
          type,
          sendId: row.sendId,
          timeStatus: row.timeStatus
        }
      });
    },
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "storeGoldBeanSendList",
        params
      );
      if (code === "0") {
        const { total, records } = result;
        this.list = records;
        this.total = total;
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    }
  }
};
</script>

<style scoped lang="scss"></style>
